// covered-by: frontends/carrie/src/routes/ask-puntt/__tests__/campaigns.test.tsx
import { useNavigate } from "@tanstack/react-router";

import { campaignRoute, campaignSearch } from "./campaignRoute";
import { askPunttProjectsRoute } from "./projectsRoute";

import {
  AskPunttProjectsView,
  formatProjectDate,
} from "../../components/ask-puntt-list/AskPunttProjectsView";
import { useStartNewProjectChat } from "../../utils/useStartNewProjectChat";

export { formatProjectDate };

export default function AskPunttCampaigns() {
  const navigate = useNavigate();
  const openProject = (projectId: string) => {
    navigate({
      to: campaignRoute.to,
      params: { projectId },
      search: campaignSearch(),
    });
  };
  const { startNewProjectChat, isPending: isStartingProject } =
    useStartNewProjectChat("ask_puntt_campaigns", openProject);

  return (
    <AskPunttProjectsView
      listTo={askPunttProjectsRoute.to}
      isStartingProject={isStartingProject}
      onOpenProject={openProject}
      onNewProject={() => {
        void startNewProjectChat("campaigns_launcher");
      }}
    />
  );
}
